import { render } from "./TimetableManager.vue?vue&type=template&id=af0a6c40&scoped=true"
import script from "./TimetableManager.vue?vue&type=script&lang=js"
export * from "./TimetableManager.vue?vue&type=script&lang=js"

import "./TimetableManager.vue?vue&type=style&index=0&id=af0a6c40&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0a6c40"]])

export default __exports__